import { queryOptions } from '@tanstack/react-query'

import { ApiConfig, clientFactory, EndpointConfig } from '@/api/clientFactory'

import {
  APIGetAvailableNotificationPreferencesResult,
  APIGetCurrentNotificationPreferencesResult,
  GetAvailableNotificationPreferencesResult,
  GetAvailableNotificationPreferencesResultSchema,
  GetCurrentNotificationPreferencesResult,
  GetCurrentNotificationPreferencesResultSchema,
  NotificationPreference,
  NotificationPreferencesNotifyFor,
} from '../domain/settings'

const basePath = '/api/notification-center'

export type UpdateNotificationPreferencesParams = {
  language?: string
  timezone?: string
  preferences?: NotificationPreference[]
  notifyFor?: NotificationPreferencesNotifyFor
  defaultSubscriptionLevel?: 'all' | 'none'
}

export const preferencesAPIConfig: ApiConfig<{
  getAvailableNotificationPreferences: EndpointConfig<
    unknown,
    APIGetAvailableNotificationPreferencesResult,
    GetAvailableNotificationPreferencesResult
  >
  getCurrentNotificationPreferences: EndpointConfig<
    unknown,
    APIGetCurrentNotificationPreferencesResult,
    GetCurrentNotificationPreferencesResult
  >
  updateNotificationPreferences: EndpointConfig<UpdateNotificationPreferencesParams, void>
}> = {
  getAvailableNotificationPreferences: {
    requestConfig: () => ({
      endpoint: `${basePath}/user-notification-preferences/available`,
      method: 'get',
      deserializationStrategy: GetAvailableNotificationPreferencesResultSchema,
    }),
  },
  getCurrentNotificationPreferences: {
    requestConfig: () => ({
      endpoint: `${basePath}/user-notification-preferences/current`,
      method: 'get',
      deserializationStrategy: GetCurrentNotificationPreferencesResultSchema,
    }),
  },
  updateNotificationPreferences: {
    requestConfig: (data) => ({
      endpoint: `${basePath}/user-notification-preferences/current`,
      method: 'post',
      body: data,
    }),
  },
}

export const preferencesClient = clientFactory(preferencesAPIConfig)

export const availableNotificationPreferencesQueryOptions = () =>
  queryOptions({
    queryKey: ['availableNotificationPreferences'],
    queryFn: preferencesClient.getAvailableNotificationPreferences,
  })

export const currentNotificationPreferencesQueryOptions = () =>
  queryOptions({
    queryKey: ['currentNotificationPreferences'],
    queryFn: preferencesClient.getCurrentNotificationPreferences,
  })
